/* globals jQuery, theme_url */

module.exports = (function($) {

    var LocationMap = function(mapElement) {

        this.initialCenter = new google.maps.LatLng(47.2493511, -122.527037);
        this.initialZoom = 12;
        this.maxZoom = 18;
        this.mapElement = mapElement;
        this.map = null;
        this.locations = [];
        this.locationMarkers = [];
        this.locationInfoWindow = new google.maps.InfoWindow();
        this.mapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"saturation":"-100"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#d2d2d2"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#12213a"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"saturation":"-100"},{"gamma":"1.90"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.landcover","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural.terrain","elementType":"all","stylers":[{"color":"#9a9a9a"},{"saturation":"6"},{"lightness":"-3"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"poi.medical","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"lightness":21},{"gamma":"0.45"}]},{"featureType":"poi.place_of_worship","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"poi.school","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"poi.sports_complex","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"},{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#dfdfdf"},{"lightness":19}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"on"},{"saturation":"-100"}]},{"featureType":"water","elementType":"all","stylers":[{"gamma":"0.00"},{"weight":"3.42"},{"saturation":"3"},{"lightness":"-9"},{"visibility":"on"},{"hue":"#009dff"}]},{"featureType":"water","elementType":"geometry","stylers":[{"saturation":"-85"},{"lightness":"39"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#1782c5"}]},{"featureType":"water","elementType":"labels.icon","stylers":[{"saturation":"-100"}]}];
        this.mapContainClass = 'archive-map';
        this.infobox = new InfoBox({
            content: '',
            disableAutoPan: false,
            maxWidth: 0,
            alignBottom: true,
            pixelOffset: new google.maps.Size(-160, -50),
            zIndex: 1,
            pane: "floatPane",
            boxStyle: {
                width: "320px"
            },
            closeBoxMargin: "12px 12px 0 0",
            closeBoxURL: theme_url + '/img/x.svg',
            infoBoxClearance: new google.maps.Size(-10, -10),
            enableEventPropagation: true
        });

    };

    /**
     * Initializes the Google map on the page and add the markers
     */
    LocationMap.prototype.initMap = function(controls, popup){

        var self = this;
        // Map arguments
        var args = {
          zoom:              this.initialZoom,
          maxZoom:           this.maxZoom,
          center:            this.initialCenter,
          mapTypeId:         google.maps.MapTypeId.ROADMAP,
          mapTypeControl:    false,
          rotateControl:     false,
          fullscreenControl: false,
          streetViewControl: false,
          disableDefaultUI:  controls==false ? true : false,
          styles:            this.mapStyles
        };

        var $markers = $('.archive-map').find('.acf-map-marker'),
            bounds = new google.maps.LatLngBounds();

        // Create map and store it for future reference
        self.map = new google.maps.Map(this.mapElement, args);

        //loop through the markers to set them
        $markers.each(function(){

            var lat = $(this).data('lat'),
                lng = $(this).data('lng'),
                directions = $(this).data('directions');

            // Marker coordinates
            var latlng = new google.maps.LatLng(lat, lng);

            // create marker
            var marker = new google.maps.Marker({
                              position: latlng,
                              map:      self.map,
                              optimized: false,
                              icon: {
                                  url: theme_url + ($(this).data('partner') ? '/img/map-pin-partner.svg' : '/img/map-pin.svg'),
                                  size: new google.maps.Size(26, 37),
                                  scaledSize: new google.maps.Size(26, 37),
                                  origin: new google.maps.Point(0, 0)
                              },
                              animation: google.maps.Animation.DROP
                          });


            self.map.setCenter(marker.position);

            if( $(this).html() && popup ){

                // extend maps bounds to inclue markers
                bounds.extend(marker.position);
                self.map.fitBounds(bounds);

                marker.popupContent = $(this).html();

              // show info window when marker is clicked
              marker.addListener('click', function() {

                  self.map.setCenter(marker.position);
                  self.infobox.setContent(marker.popupContent);
                  self.infobox.open(self.map, marker);

              });

            }

            if( !popup && directions.length > 0 ){
                marker.addListener('click', function(){
                    window.open(directions, '_blank');
                });
            }

        }); //endfor each marker

        if( $markers.length == 1 ){
            self.map.setZoom(12);
        }

    };//initMap


      // Return our WineryMap function so we can use it outside the current scope
      return LocationMap;

})(jQuery);
